module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f62d.f7b3f6b9.svg";